import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { setRestGoodsFormAction } from "../../redux/rootReducer";
import { REST_GOODS_FORM_INITIAL } from "../../redux/initialStateConstant";
import { updateGoodsRestSagaAction } from "../../redux/sagaActions";

const GoodsRestForm = () => {
    const dispatch = useDispatch();
    const rest_goods_form = useSelector(state => state.rest_goods_form);

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <div className="form__close" onClick={ () => dispatch(setRestGoodsFormAction(REST_GOODS_FORM_INITIAL)) }/>
                        <div className="form__title">Склад</div>
                    </div>
                    <div className="form__field">
                        <div className="input__caption">Количество</div>
                        <input type="text" className="input"
                            value={ rest_goods_form.rest }
                            onInput={ event => dispatch(setRestGoodsFormAction({ ...rest_goods_form, rest: event.target.value })) }
                        />
                    </div>
                    <div className="form__field">
                        <div className="button"
                            onClick={ () => dispatch(updateGoodsRestSagaAction({
                                goods_id: rest_goods_form.goods_id,
                                rest: rest_goods_form.rest
                            })) }
                        >Сохранить</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GoodsRestForm;